const STORAGE_KEYS = {
  authorization: 'yowan_authorization_v1',
  accessToken: 'yowan_access_token_v1',
  refreshToken: 'yowan_refresh_token_v1',
  authDomain: 'yowan_auth_domain_v1',
  authSummary: 'yowan_auth_summary_v1',
};
const LEGACY_SNAPSHOT_KEYS = [
  'yowan_auth_me_v1',
  'yowan_access_me_v1',
  'yowan_admin_status_v1',
];

const readText = (key) => {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.localStorage.getItem(key);
};

const writeText = (key, value) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (value === null || value === undefined || value === '') {
    window.localStorage.removeItem(key);
    return;
  }

  window.localStorage.setItem(key, value);
};

export const storeYowanTokens = ({ access, refresh, authDomain, auth_domain: authDomainAlias }) => {
  clearLegacyYowanSnapshotStorage();
  writeText(STORAGE_KEYS.authorization, 'true');
  writeText(STORAGE_KEYS.accessToken, access);
  writeText(STORAGE_KEYS.refreshToken, refresh);
  writeText(STORAGE_KEYS.authDomain, authDomain || authDomainAlias);
};

export const storeYowanAuthSummary = (authSummary = null) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (!authSummary) {
    window.localStorage.removeItem(STORAGE_KEYS.authSummary);
    return;
  }

  window.localStorage.setItem(STORAGE_KEYS.authSummary, JSON.stringify(authSummary));
};

export const updateYowanStoredTokens = ({ access, refresh, authDomain, auth_domain: authDomainAlias } = {}) => {
  clearLegacyYowanSnapshotStorage();
  writeText(STORAGE_KEYS.authorization, 'true');

  if (access !== undefined) {
    writeText(STORAGE_KEYS.accessToken, access);
  }

  if (refresh !== undefined) {
    writeText(STORAGE_KEYS.refreshToken, refresh);
  }

  const nextAuthDomain = authDomain || authDomainAlias;

  if (nextAuthDomain !== undefined) {
    writeText(STORAGE_KEYS.authDomain, nextAuthDomain);
  }
};

export const clearLegacyYowanSnapshotStorage = () => {
  if (typeof window === 'undefined') {
    return;
  }

  LEGACY_SNAPSHOT_KEYS.forEach((key) => {
    window.localStorage.removeItem(key);
  });
};

export const clearYowanStoredSession = () => {
  if (typeof window === 'undefined') {
    return;
  }

  Object.values(STORAGE_KEYS).forEach((key) => {
    window.localStorage.removeItem(key);
  });
  clearLegacyYowanSnapshotStorage();
};

export const readYowanStoredAuthSummary = () => {
  const raw = readText(STORAGE_KEYS.authSummary);

  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch (error) {
    return null;
  }
};

export const readYowanStoredSnapshot = () => {
  clearLegacyYowanSnapshotStorage();
  const accessToken = readText(STORAGE_KEYS.accessToken);
  const refreshToken = readText(STORAGE_KEYS.refreshToken);

  return {
    isAuthenticated: Boolean(readText(STORAGE_KEYS.authorization) && accessToken && refreshToken),
    accessToken,
    refreshToken,
    authDomain: readText(STORAGE_KEYS.authDomain),
    authSummary: readYowanStoredAuthSummary(),
  };
};
